import { Injectable } from "@angular/core";
import { idField, ReferenceField } from "@common/references/reference-field";
import { DefaultService } from "@common/references/default.service";
import urlJoin from "url-join";
import { environment } from "@environments/environment";
import { meterType } from '@modules/settings/meter-type/meter-type.interfaces';
import { MeterTypeFormComponent } from '@modules/settings/meter-type/meter-type-form/meter-type-form.component';

@Injectable({
  providedIn: "root",
})
export class MeterTypeService extends DefaultService<meterType> {
  backendName = 'meter-types';
  formComponent = MeterTypeFormComponent;
  title = 'MENU.METER_TYPES';
  titleSingular = `METER_TYPE`;
  fields: ReferenceField[] = [
    {...idField, table: false},
    {fieldName: 'code', label: 'CITY.CODE', iconClass: 'lab la-centercode', filter: true},
    {fieldName: 'name', label: 'CITY.NAME', iconClass: 'las la-user', filter: true},
    {fieldName: 'model', label: 'METER_TYPE.MODEL', iconClass: 'las la-sd-card', filter: true},
    {fieldName: 'manufacture', label: 'METER_TYPE.MANUFACTURE', iconClass: 'las la-building', filter: true},
    {fieldName: 'manufactureDate', label: 'METER_TYPE.MANUFACTURE_DATE', iconClass: 'las la-calendar'},
    {
      fieldName: 'utilityProvider',
      label: 'MENU.UTILITY_PROVIDERS',
      iconClass: 'las la-cube',
      fieldValue: (item,data) => data?.utilityProviderType?.utilityProvider?.name,
      filter: true
    },
    {
      fieldName: 'utilityProviderType',
      label: 'METER_TYPE.UTILITY_TYPE',
      iconClass: 'las la-cube',
      viewType: 'unitType',
      filter: true
    },
    {fieldName: 'capacity', label: 'METER_TYPE.CAPACITY', iconClass: 'lab la-empire', filter: true},
    {
      fieldName: 'certification',
      label: 'METER_TYPE.CERTIFICATION',
      iconClass: 'las la-certificate',
      table: false,
      filter: true
    },
    {
      fieldName: 'certificationBody',
      label: 'METER_TYPE.CERTIFICATION_BODY',
      iconClass: 'las la-certificate',
      table: false,
      filter: true,
    },
    {
      fieldName: 'status',
      label: 'CITY.STATUS',
      viewType: 'status',
      iconClass: 'las la-toggle-on',
      filter: {type: "boolean"}
    },
  ];
  hasActions = true;
  hasAdd = true;
  hasDelete = true;

  getUrl(): string {
    return urlJoin(environment.apiUrl, 'meter-types');
  }
}
